import React from "react";
import { Link } from "react-router-dom";
import { Minus, Plus, Trash2, ArrowRight } from "lucide-react";
import { useCart } from "../../context/CartContext";

export default function Cart() {
  const { items, removeFromCart, updateQty, subtotal } = useCart();
  const shipping = subtotal > 0 && subtotal < 500 ? 0 : 0;
  const tax = subtotal * 0.0;

  return (
    <div data-testid="cart-page" className="bg-poche-black text-white min-h-[70vh]">
      <section className="container-x py-16">
        <p className="text-[11px] tracking-luxury uppercase text-poche-gold">Your Cart</p>
        <h1 className="font-serif text-5xl md:text-6xl mt-3">The Atelier Bag.</h1>

        {items.length === 0 ? (
          <div className="mt-20 text-center" data-testid="empty-cart">
            <p className="text-white/55 text-lg">Your cart awaits its first piece.</p>
            <Link to="/shop" className="btn-gold mt-8 inline-flex">Enter the collection</Link>
          </div>
        ) : (
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 mt-12">
            <div className="lg:col-span-8 divide-y divide-white/10 border-t border-b border-white/10">
              {items.map((i) => (
                <div key={i.product_id} className="flex gap-6 py-6">
                  <div className="bg-poche-ivory w-32 h-32 flex-shrink-0 overflow-hidden">
                    <img src={i.image} alt={i.name} className="w-full h-full object-cover" />
                  </div>
                  <div className="flex-1">
                    <div className="text-[11px] tracking-luxury uppercase text-white/55">{i.name}</div>
                    <Link to={`/product/${i.product_id}`} className="font-serif text-2xl hover:text-poche-gold">{i.subtitle}</Link>
                    <div className="text-poche-gold font-serif text-xl mt-2">${(i.price * i.qty).toLocaleString()}</div>
                    <div className="flex items-center gap-6 mt-4">
                      <div className="flex items-center border border-white/15">
                        <button data-testid={`qty-minus-${i.product_id}`} onClick={() => updateQty(i.product_id, i.qty - 1)} className="p-2 hover:text-poche-gold"><Minus size={14} /></button>
                        <span className="px-4 text-sm">{i.qty}</span>
                        <button data-testid={`qty-plus-${i.product_id}`} onClick={() => updateQty(i.product_id, i.qty + 1)} className="p-2 hover:text-poche-gold"><Plus size={14} /></button>
                      </div>
                      <button data-testid={`remove-${i.product_id}`} onClick={() => removeFromCart(i.product_id)} className="text-xs tracking-luxury uppercase text-white/55 hover:text-poche-gold flex items-center gap-2"><Trash2 size={12} /> Remove</button>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <div className="lg:col-span-4">
              <div className="border border-white/10 p-8 sticky top-28">
                <h3 className="font-serif text-2xl">Summary</h3>
                <div className="mt-6 space-y-3 text-sm">
                  <Row l="Subtotal" v={`$${subtotal.toLocaleString()}`} />
                  <Row l="Shipping" v={shipping === 0 ? "Complimentary" : `$${shipping}`} />
                  <Row l="Estimated Tax" v={`$${tax.toFixed(2)}`} />
                </div>
                <div className="border-t border-white/15 mt-6 pt-6 flex items-center justify-between">
                  <span className="text-[11px] tracking-luxury uppercase text-white/55">Total</span>
                  <span className="font-serif text-3xl text-poche-gold">${(subtotal + shipping + tax).toLocaleString()}</span>
                </div>
                <Link to="/checkout" data-testid="checkout-cta" className="btn-gold w-full justify-center mt-6">
                  Checkout <ArrowRight size={14} />
                </Link>
                <p className="text-[10px] tracking-luxury uppercase text-white/35 text-center mt-4">2-year house warranty included</p>
              </div>
            </div>
          </div>
        )}
      </section>
    </div>
  );
}

function Row({ l, v }) {
  return (
    <div className="flex items-center justify-between text-white/75">
      <span>{l}</span><span>{v}</span>
    </div>
  );
}
